import Wix from './wix-sdk-polyfill';
import { MERGE_GLOBAL_SETTING_IN_STORE } from '../actions/settings';
import { sendActionToFrames } from './frames-messages';

export default function listenToSettingsChange(store) {
  // Expecting a redux-type message to be received from app settings on what to execute
  Wix.addEventListener(Wix.Events.SETTINGS_UPDATED, (msg) => handleSettingsUpdated(msg, store));
}

function handleSettingsUpdated(message, store) {
  if (!message || !message.type) {
    return;
  }

  const isMergeGlobalSettingsAction = message.type === MERGE_GLOBAL_SETTING_IN_STORE;

  if (isMergeGlobalSettingsAction) {
    sendActionToFrames(message);
  }

  store.dispatch(message);
}
